/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { paymentMethodPrimary } from '../../axios/paymentMethodPrimary'
import type {
	PaymentMethodPrimaryError,
	PaymentMethodPrimaryPathParams,
	PaymentMethodPrimaryResponse,
} from '../../types/PaymentMethodPrimary'

export const paymentMethodPrimaryMutationKey = () =>
	[{ url: '/:organisation/payment-methods/:paymentMethod/primary' }] as const

export type PaymentMethodPrimaryMutationKey = ReturnType<typeof paymentMethodPrimaryMutationKey>

export type PaymentMethodPrimaryVariables = {
	organisation: PaymentMethodPrimaryPathParams['organisation']
	paymentMethod: PaymentMethodPrimaryPathParams['paymentMethod']
}

/** @see backend/nexus/modules/Billing/Http/Controllers/PaymentMethodController.php PaymentMethodController::primary */
export function usePaymentMethodPrimary<TContext = unknown>(
	options?: UseMutationOptions<
		PaymentMethodPrimaryResponse,
		AxiosError<PaymentMethodPrimaryError>,
		PaymentMethodPrimaryVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: paymentMethodPrimaryMutationKey(),
		mutationFn: ({ organisation, paymentMethod }: PaymentMethodPrimaryVariables) =>
			paymentMethodPrimary(organisation, paymentMethod, config).then(res => res.data),
		...options,
	})
}
